import {
  Button,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { MdArrowUpward } from 'react-icons/md';

const ChatBotFooter = ({ addQuestion, isEnabled }) => {
  const inputRef = useRef();

  const handleClick = () => {
    // check if the input is empty
    if (!inputRef.current.value) {
      return;
    }

    addQuestion(inputRef.current.value);
    inputRef.current.value = '';
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Flex justifyContent="center" width="100%">
      <InputGroup size="md" maxWidth="700px">
        <Input
          textColor="#1B2559"
          ref={inputRef}
          placeholder="Send a message"
          onKeyDown={handleKeyDown}
          isDisabled={!isEnabled}
        />
        <InputRightElement width="4.5rem">
          <Button
            h="1.75rem"
            size="sm"
            onClick={handleClick}
            isDisabled={!isEnabled}
          >
            <Icon as={MdArrowUpward} />
          </Button>
        </InputRightElement>
      </InputGroup>
    </Flex>
  );
};

export default ChatBotFooter;
